import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { TYPES } from './types'
import * as kanbanController from 'controller/kanbanController'
import * as kanbanActions from 'store/modules/kanban/actions'
import * as loadingActions from 'store/modules/loading/actions'
import { handlerError } from 'util/handlerError'

function* getKanbanSaga(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(kanbanController.getKanban)
    yield put(kanbanActions.setKanban(response?.data?.content))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

export function* watchGetKanbanSaga() {
  yield takeLatest(TYPES.GET_KANBAN_SAGA, getKanbanSaga)
}

function* kanbanSaga() {
  yield all([fork(watchGetKanbanSaga)])
}

export default kanbanSaga
